globalThis.VRT = globalThis.VRT || {};

const { VRT } = globalThis;

const { cancelResumePage } = VRT.SSOConfig;
const ssoLoginPath = `/${VRT.SSOConfig.ssoPath}/login`;
const params = new URLSearchParams(globalThis.location.search);
const scope = params.get('scope');
const idToken = params.get('id_token'); // 'id_token_hint' is reserved for sso controller

function isLoggedIn(event) {
  return event && event.detail && event.detail.state > 0;
}

function composeURL(prompt, scopes, idTokenHint) {
  const queryParams = new URLSearchParams();
  queryParams.append('channel', 'tv app');
  if (prompt) queryParams.append('prompt', prompt);
  if (scopes) queryParams.append('scope', scopes);
  if (idTokenHint) queryParams.append('id_token_hint', idTokenHint);

  const resumePage = globalThis.location.href.split('?')[0] + (params.toString() ? `?${params.toString()}` : '');
  queryParams.append('resumePage', resumePage);
  if (cancelResumePage) queryParams.append('cancelResumePage', cancelResumePage);

  return `${ssoLoginPath}?${queryParams}`;
}

const handleSSOStateChange = (event) => {
  if (isLoggedIn(event)) {
    const isMainProfile = event.detail.currentProfile.profileType === 'main';
    if (isMainProfile) {
      VRT.SSOController.getIdToken((newIdToken) => {
        let userCode = params.get('user_code');
        userCode = userCode ? `&user_code=${userCode}` : '';
        const environment = VRT.SSOController.environment === 'prod' ? '' : `-${VRT.SSOController.environment}`;
        const loginDomain = `login${environment}.vrt.be`;
        globalThis.location = `https://${loginDomain}/tv?client_id=${VRT.SSOConfig.clientId}&id_token_hint=${newIdToken}&channel=tv+app${userCode}`;
      }, 600000 /* 10 minutes in milliseconds */);
    } else {
      globalThis.location = composeURL('login');
    }
  } else {
    globalThis.location = composeURL();
  }
};

if (params.get('prompt') === 'login') {
  params.delete('prompt');
  globalThis.location = composeURL('login');
} else if (scope && idToken) {
  params.delete('scope');
  params.delete('id_token');
  globalThis.location = composeURL('consent', scope, idToken);
} else {
  globalThis.onload = () => {
    VRT.SSOController.addEventListener('SSO-stateChanged', handleSSOStateChange);
  };
}
